<template>
  <section class="nogame">
    <div class="nogame__inner">
      <h1 class="nogame__title text-funky">Game not available</h1>
      <p class="nogame__lede">There is no game scheduled right now. Please check back a little later.</p>
    </div>
  </section>
</template>

<script>
  export default {
    name: "NoGame"
  };
</script>

<style scoped>
  .nogame {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 24px 16px;
    background: #1f2430;
  }

  .nogame__inner {
    max-width: 420px;
    color: #fff;
  }

  .nogame__title {
    margin: 0 0 14px;
    font-size: clamp(17px, 5vw, 24px);
    line-height: 1.5;
  }

  .nogame__lede {
    margin: 0;
    font-weight: 400;
    line-height: 1.6;
    opacity: 0.75;
  }
</style>
